import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  showDeleteAccTncDialog: boolean = false;
  showDeleteAccDialog: boolean = false;
  displayLanguageDialog : boolean = false;

  constructor(
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void { }

  onNavigate(dt: string) {
    switch (dt) {
      case 'privacyPolicy': {
        this.navigationService.openInNewTab('privacy-policy', true);
        break;
      }
      case 'tnc': {
        this.navigationService.openInNewTab('term-conditions', true);
        break;
      }
      default: {
        this.navigationService.navigateByUrl("/");
        break;
      }
    }
  }

  onClickDeleteAcc() {
    this.showDeleteAccTncDialog = true;
  }

  onClickBack() {
    this.navigationService.navigate(['profiles']);
  }

  get currentLang(): string | null {
    return localStorage.getItem('lang');
  }
}
